<template>
  <div class="w-full">
    <div class="flex items-center justify-between">
      <h3 class="py-0 my-0 text-xl text-gray-800">
        Autohaus {{ dealer.item_name }}
      </h3>
    </div>
    <div class="mt-6">
      <mia-wait for="loading dealer">
        <template #waiting>
          <div class="flex items-center justify-center py-8">
            <mia-wave-loader />
          </div>
        </template>

        <template #default>
          <div class="flex gap-4">
            <div class="w-1/2 flex flex-col mb-4">
              <label>Übergeordnete Händler</label>
              <select
                v-model="selectedSources"
                class="w-full"
                multiple
              >
                <option
                  v-for="dealeroption in dealerlist"
                  :key="dealeroption.id"
                  :value="dealeroption.id"
                  :selected="itemSources.includes(dealeroption.id)"
                >
                  {{ dealeroption.item_name }}
                </option>
              </select>
            </div>
            <div class="w-1/2 flex flex-col mb-4">
              <label>Hersteller</label>
              <div
                v-for="selected in selectedSources"
                :key="selected"
                class="mb-4"
              >
                <span class="text-xs font-semibold">{{ getDealerName(selected) }}:</span>
                <div class="w-full">
                  <select
                    v-model="dealerMakes[selected].make"
                    class="w-full h-8"
                    multiple
                  >
                    <option
                      value=""
                      disabled
                    >
                      Hersteller suchen
                    </option>
                    <option
                      v-for="make in makes"
                      :key="make.name"
                      :value="make.name"
                    >
                      {{ make.name }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div class="w-full flex mb-4 justify-end">
            <mia-loading-button
              class="text-white bg-blue-500 hover:bg-blue-600"
              type="button"
              @click="update"
            >
              Änderungen speichern
            </mia-loading-button>
          </div>
          <datatable
            :columns="columns"
            :data="dealer.item_features"
            class="sticky w-full table-auto datatable"
          >
            <template #no-results>
              <div class="text-center">
                Für die gewählten Filter wurden keine Einträge gefunden.
              </div>
            </template>
          </datatable>
        </template>
      </mia-wait>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      dealer: null,
      dealerlist: [],
      makes: [],
      dealerMakes: {},
      selectedSources: [],
      columns: [
        {
          field: 'item_title',
          label: 'Feature',
          headerAlign: 'left'
        },
        {
          field: 'item_category',
          label: 'Kategorie',
          headerAlign: 'left'
        },
        {
          field: 'item_price',
          label: 'Preis',
          headerAlign: 'left'
        },
        {
          field: 'item_price_per_month',
          label: 'Monatlicher Preis',
          headerAlign: 'left'
        },
        {
          field: 'item_price_per_car',
          label: 'Preis pro Fahrzeug',
          headerAlign: 'left'
        }
      ]
    }
  },
  computed: {
    dealerId() {
      return parseInt(this.$route.params.id, 10)
    },

    itemSources() {
      return this.dealer.item_sources.map(source => source.item_source)
    }
  },

  watch: {
    selectedSources: {
      immediate: true,
      handler(dealers) {
        this.dealerMakes = {};
        [...dealers].forEach((dealer) => {
          if (!this.dealerMakes[dealer]) {
            this.dealerMakes[dealer] = { make: this.getSourceDealer(dealer) }
          }
        })
      }
    }
  },

  mounted() {
    eventBus.$emit('mia-loading-ended')
  },

  created() {
    this.loadDealerlist()
    this.loadDealer()
    this.loadMakes()
  },

  methods: {
    getDealerName(id) {
      return this.dealerlist.find(dealer => parseInt(dealer.id) === parseInt(id))?.item_name
    },

    getSourceDealer(id) {
      return this.dealer.item_sources.filter(source => parseInt(source.item_source) === parseInt(id)).map(source => source.item_mobile_make)
    },

    loadMakes() {
      axios.get(`${window.baseUrl}/mobile/makes`)
        .then(({ data }) => {
          this.makes = data.values
        })
    },

    loadDealerlist() {
      this.$wait.start('loading dealers')
      axios.get(`${window.baseUrl}/user/dealerlist`).then(({ data }) => {
        // Autohaus Schmitz GmbH & AHS always first
        const alwaysFirstDealers = [1, 2]
        const ahsDealers = data.dealerlist.filter(dealer => alwaysFirstDealers.includes(parseInt(dealer.id, 10)))
        const otherDealers = data.dealerlist.filter(dealer => !alwaysFirstDealers.includes(parseInt(dealer.id, 10)))

        this.dealerlist = [
          ...ahsDealers,
          ...otherDealers
        ]
        this.$wait.end('loading dealers')
      }).catch(() => {
        console.log('failed fetching dealer list 😭')
        this.$wait.end('loading dealers')
      })
    },

    loadDealer() {
      this.$wait.start('loading dealers')
      axios.get(`${window.baseUrl}/dealer/getDealer/${this.dealerId}`).then(({ data }) => {
        this.dealer = data
        this.selectedSources = data.item_sources.map(source => source.item_source).filter((value, index, array) => array.indexOf(value) === index)
        this.$wait.end('loading dealers')
      }).catch(() => {
        console.log('failed fetching dealer 😭')
        this.$wait.end('loading dealers')
      })
    },

    update() {
      const payload = { dealerMakes: this.dealerMakes }
      this.$wait.start('loading dealers')
      axios.post(`${window.baseUrl}/dealer/updateAttachedDealersList/${this.dealerId}`, payload).then(({ data }) => {
        window.eventBus.$emit('mia-info', {
          info: ['Daten erfolgreich gespeichert.']
        })
        this.loadDealer()
      }).catch(() => {
        console.log('failed fetching dealer 😭')
        this.$wait.end('loading dealers')
      })
    }

  }
}
</script>
